import { WritePermissionKey } from "constants/permissions";
import { ComponentType } from "react";

export const QUICK_NAV_CONDITION = {
  PRE_INCORPORATE: "PRE_INCORPORATE",
  HAS_INDIAN_ENTITY: "HAS_INDIAN_ENTITY",
} as const;

export type QuickNavCondition =
  (typeof QUICK_NAV_CONDITION)[keyof typeof QUICK_NAV_CONDITION];

export type QuickNavPage = {
  name: string;
  path: string;
  permissionKey?: WritePermissionKey;
  conditions?: QuickNavCondition[];
  query?: Record<string, string | boolean>;
  icon?: ComponentType;
};
